import DOMPurify from "dompurify";

export function sanitizeHtmlForDisplay(html: string): string {
  return DOMPurify.sanitize(html);
}
